import { Industry } from '@youshift/shared/types';
import { Outlet, useParams } from 'react-router-dom';

export default function AuthLayout() {
  const { industry: industryStr = '' } = useParams();
  const industry =
    industryStr.toUpperCase() in Industry
      ? (industryStr.toUpperCase() as Industry)
      : Industry.OTHER;

  return (
    <div className="flex min-h-screen align-center">
      <Outlet />
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          className="absolute inset-0 h-full w-full object-cover min-h-screen"
          src={`${process.env.REACT_APP_S3_DOCS_URL}/signup-pictures/${industry.toLowerCase()}.jpg`}
          alt=""
        />
      </div>
    </div>
  );
}
